<tt-page *ngIf="!!setting">
    <tt-page-heading *ngIf="!!setting.sop_name" [ttModel]="setting.sop_name"></tt-page-heading>

    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-button-goto ttText="sopcls_new" ttGoto="sopcl" [ttGotoParms]="{ sop_keyno: setting.sop_keyno, sopcl_keyno: '0' }" ttIcon="far fa-plus"></tt-button-goto>
    </tt-card>

    <tt-list class="col-xs-12 col-md-4 sp-0" [ttData]="itemsListChoices"></tt-list>
</tt-page>
